import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { GetEk83ReportListPagingAndFilterRequest } from '../models/request/report/GetEk83ReportListPagingAndFilterRequest';
import { GetDailyReportListPagingAndFilterRequest } from '../models/request/report/GetDailyReportListPagingAndFilterRequest';
import { GetDailyKmAndFuelReportListPagingAndFilterRequest } from '../models/request/report/GetDailyKmAndFuelReportListPagingAndFilterRequest';
import { GetIdleReportListPagingAndFilterRequest } from '../models/request/report/GetIdleReportListPagingAndFilterRequest';

export class ReportService {
    static async getEk83ReportListPagingAndFilter(inputObj: GetEk83ReportListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetEk83ReportListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Report/GetEk83ReportPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportEk83ReportList(inputObj: GetEk83ReportListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportEk83ReportList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Report/ExportEk83Report', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getDailyReportListPagingAndFilter(inputObj: GetDailyReportListPagingAndFilterRequest) {
        try {
            inputObj = {
                ...inputObj,
                startDateStr: inputObj?.startDateStr?.replace('T', ' ') + ':00',
                endDateStr: inputObj?.endDateStr?.replace('T', ' ') + ':00',
            }

            console.log('SERVICE CALL - GetDailyReportListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Report/GetDailyReportPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportDailyReportList(inputObj: GetDailyReportListPagingAndFilterRequest) {
        try {
            inputObj = {
                ...inputObj,
                startDateStr: inputObj?.startDateStr?.replace('T', ' ') + ':00',
                endDateStr: inputObj?.endDateStr?.replace('T', ' ') + ':00',
            }

            console.log('SERVICE CALL - exportDailyReportList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Report/ExportDailyReport', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getDailyKmAndFuelReportListPagingAndFilter(inputObj: GetDailyKmAndFuelReportListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetDailyKmAndFuelReportListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Report/GetDailyKmAndFuelReportPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportDailyKmAndFuelReportList(inputObj: GetDailyKmAndFuelReportListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportDailyKmAndFuelReportList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Report/ExportDailyKmAndFuelReport', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getIdleReportListPagingAndFilter(inputObj: GetIdleReportListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetIdleReportListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Report/GetIdleReportPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportIdleReportList(inputObj: GetIdleReportListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportIdleReportList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Report/ExportIdleReport', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

}